import { useMemo } from 'react';
import type { TMap } from '@shared/types';
import type { TUser } from '@modules/users/types/users.types';
import type { TProject } from '../types';

/** Ids of users outside the Project, so assignee pickers list only its leads and members. */
export const useExcludedAssigneeIds = (
  { leads, members }: Pick<TProject, 'leads' | 'members'>,
  userMap?: TMap<string, TUser>
) =>
  useMemo(() => {
    const participants = new Set([...leads, ...members]);
    return Object.keys(userMap ?? {}).filter((id) => !participants.has(id));
  }, [leads, members, userMap]);
